import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    form: {
      width: '100%',
      minHeight: '50vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      justifyContent: 'space-between',
      fontSize: 16,
      padding: '50px 0',
    },
    formContent: {
      '& > div': {
        marginBottom: 30,
      },
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
    },
    input: {
      display: 'block',
      flex: 1,
      maxWidth: 100,
      border: `1px solid ${theme.palette.grey[600]}`,
      background: theme.palette.grey[800],
      borderRadius: 8,
      padding: '0 10px',
      textAlign: 'center',
      fontSize: 16,
      height: '2rem',
      '&:before': {
        borderBottom: 'none',
      },
    },

    numberRange: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      // textAlign: 'justify',
      // '& input': {
      // },
    },

    options: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    result: {
      width: '100%',
      borderRadius: 8,
      border: `1px solid ${theme.palette.grey[600]}`,
      background: theme.palette.grey[800],
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',

      padding: '30px 50px',
      marginTop: 30,
    },

    error: {
      width: '100%',
      borderRadius: 8,
      border: `1px solid ${theme.palette.grey[600]}`,
      background: theme.palette.grey[800],
      color: theme.palette.error.main,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      padding: '30px 50px',
      marginTop: 30,

      '& svg': {
        fontSize: 32,
        marginRight: 15,
        // border: `2px solid ${theme.palette.error.main}`,
        background: '#F2F0FE',
        borderRadius: '50%',
        height: 60,
        minWidth: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 12px',
      },
    },
    log: {
      width: '100%',
      textAlign: 'center',
      border: `1px solid ${theme.palette.grey[600]}`,
      background: theme.palette.grey[800],
      marginTop: 10,

      '& .MuiGrid-item': {
        width: '100%',
        padding: '10px 20px',
      },
      alignItems: 'center',
      justifyContent: 'center',
    },
    logs: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },

    cleanLog: {
      border: 'none',
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      height: '45px',
      width: '50%',
      borderRadius: 5,
      fontWeight: 'bold',
      marginTop: 30,

      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        cursor: 'pointer',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  }),
);

export default useStyles;
